export default __webpack_public_path__ + "static/media/offence-classicon.ce452cc8.webp";